// extracted by mini-css-extract-plugin
export default {"link":"NavLink_link__FAIIR","link_active":"NavLink_link_active__ZWz9Z","icon":"NavLink_icon__OIJrq"};